<template>
  <div class="create-post-comp">
    <div class="d-flex align-items-center mb-5 mob-shadow">
      <font-awesome-icon :icon="['far', 'arrow-left']" class="cp gray400 mr-4" @click="changeScreen('back')" />
      <h4 class="fw700 font24 gray700 ml-1 mb-0">Choose link preview</h4>
      <font-awesome-icon size="2x" :icon="['fal', 'times']" class="font-black ml-auto cp font20" @click="hide" />
    </div>

    <SimpleLoader v-if="loading" :name="'link previews'" />

    <template v-else>
      <div v-for="previews in previewedLinks" :key="previews" class="mt-4 cp" @click="handleSelectLink(previews.orgURL)">
        <img :src="previews.image" alt="preview-img" :style="{ 'object-fit': 'contain', height: '278px', width: '100%' }" v-if="previews.image" />
        <div class="p-3 bg-gray100" :style="{ 'border-radius': '0px 0px 8px 8px' }">
          <p class="mb-0 gray900 font16 fw700">{{ previews.title }}</p>
          <p class="mb-0 gray600 font16">{{ previews.shortened_url }}</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import SimpleLoader from "../../commons/SimpleLoader.vue"

const PostRepository = RepositoryFactory.get("posts")

export default {
  components: { SimpleLoader },
  name: "LinkPreviewScreen",
  props: { linksToPreview: Array, changeScreen: Function, hide: Function, selectLink: Function },
  data() {
    return { previewedLinks: [], loading: false }
  },
  methods: {
    handleSelectLink(link) {
      this.selectLink(link)
      this.changeScreen("back")
    },
  },
  mounted() {
    try {
      this.loading = true
      this.linksToPreview.forEach(async link => {
        const res = await PostRepository.parseLink({ url: link })
        this.previewedLinks.push({ ...res.data, orgURL: link })
        this.loading = false
      })
    } catch (e) {
      console.log(e)
      this.loading = false
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/home/createNewPost/LinkPreview.vue